const STORAGE_TYPES = Object.freeze({
    ORGANIZATION_ELEMENT: { id: 'ORGANIZATION_ELEMENT', canStore: false, icon: '$wOrganizationElement' },
    UNIVERSAL_STORAGE: { id: 'UNIVERSAL_STORAGE', canStore: true, icon: '$wUniversalStorage' },
    PRODUCT_STORAGE: { id: 'PRODUCT_STORAGE', canStore: true, icon: '$wProductStorage' }
  });
  
  export default STORAGE_TYPES;